import React, { useEffect, useState } from "react";
import { get, post } from "../../apiService";
import OTPInput, { ResendOTP } from "otp-input-react";
import countriesData from "./countries.json";

import { Button, Form, Input, Select, message } from "antd";
import "../Registration/Registration.css";
import { BiSolidCheckboxChecked } from "react-icons/bi";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { MdCall, MdEmail } from "react-icons/md";
import { GiWorld } from "react-icons/gi";

const { Option } = Select;

const Account = ({
  form,
  formData,
  setFormData,
  verifyEmail,
  setVerifyEmail,
  setIsUsernameAvailable,
  setIsPhoneNumberAvailable,
  setIsEmailAvailable,
}) => {
  const [otpSent, setOtpSent] = useState(false);
  const [OTP, setOTP] = useState("");
  const [referBy, setReferBy] = useState([]);
  const { countries } = countriesData;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const dbounce = setTimeout(() => {
      fetchReferby();
    }, 300);

    return () => clearTimeout(dbounce);
  }, []);

  // setCountriess(countries);
  const fetchReferby = async () => {
    try {
      const action = "fetch";
      const limit = 10;
      const page = 1;
      const type = "staff";
      const response = await get(
        `/user.php?action=${action}&limit=${limit}&page=${page}&type=${type}`
      );
      setReferBy(response.list);
      // console.log(response);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCountryChange = (value) => {
    setFormData({ ...formData, country: value });
  };

  // Custom validation function
  const validateConfirmPassword = (_, value) => {
    if (!value || value === form.getFieldValue("password")) {
      return Promise.resolve();
    }
    return Promise.reject(new Error("Passwords do not match"));
  };
  const debounce = (func, delay) => {
    let timerId;
    return (...args) => {
      if (timerId) {
        clearTimeout(timerId);
      }
      timerId = setTimeout(() => func(...args), delay);
    };
  };
  const checkAvailability = debounce(async (type, value) => {
    // Validate phone number length
    if (type === "number" && value.length !== 10) {
      message.error("Phone number must be exactly 10 digits.");
      return;
    }

    // Validate email format
    if (type === "user_email" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      message.error("Invalid email format.");

      return;
    }

    const formData = new FormData();
    formData.append("typeCheck", type);
    formData.append("typeValue", value);
    formData.append("type", "user");
    formData.append("action", "checkInputDetail");

    try {
      const response = await post("/user.php", formData);
      console.log(response);
      if (response.status === 200) {
        message.success(
          `${type.charAt(0).toUpperCase() + type.slice(1)} is available.`
        );
        if (type === "user_name") setIsUsernameAvailable(true);
        if (type === "number") setIsPhoneNumberAvailable(true);
        if (type === "user_email") setIsEmailAvailable(true);
      }
    } catch (error) {
      message.error(
        `${type.charAt(0).toUpperCase() + type.slice(1)} is already registered.`
      );
      if (type === "user_name") {
        setIsUsernameAvailable(false);
        form.setFields([
          {
            name: "username", // required
            errors: ["Username already used !"],
          },
        ]);
      }
      if (type === "number") {
        setIsPhoneNumberAvailable(false);
        form.setFields([
          {
            name: "phoneNumber", // required
            errors: ["Phone Number already registred !"],
          },
        ]);
      }
      if (type === "user_email") {
        setIsEmailAvailable(false);
        form.setFields([
          {
            name: "user_email", // required
            errors: ["Email Id already registred !"],
          },
        ]);
      }
    }
  }, 500); // Debounce delay in milliseconds

  console.log(form);
  // const getOtp = async
  const handleEmailVerification = async () => {
    // if (isEmailAvailable) {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const emailAndt = form.getFieldValue("email");
    if (!emailPattern.test(emailAndt)) {
      setOtpSent(false);
      message.error("Please enter a valid email address.");
      return;
    }
    setLoading(true);
    const formDatas = new FormData();
    formDatas.append("user_email", emailAndt);
    formDatas.append("action", "register");

    try {
      const response = await post("/user.php", formDatas);
      const result = response.data;

      if (response.status === 200) {
        message.success("Otp Send successfully!");
        // message.success('Email verified successfully!');
        setOtpSent(true);
      } else {
        message.error(result.message || "Failed to verify email.");
      }
    } catch (error) {
      if (error.response) {
        message.error(error.response.data.message || "Failed to verify email.");
      } else if (error.request) {
        message.error("No response received from the server.");
      } else {
        message.error("An error occurred while verifying the email.");
      }
    } finally {
      setLoading(false);
    }
    // } else {
    //   message.error("An error occurred while verifying the email");
    // }
  };

  const sumbitOtp = async (e) => {
    const emailAndt = form.getFieldValue("email");
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(emailAndt)) {
      setOtpSent(false);
      message.error("Please enter a valid email address.");

      return;
    }
    // setOtpSent(true);

    // message.success('Otp Send successfully!');
    const formDatas = new FormData();
    formDatas.append("user_email", emailAndt);
    formDatas.append("action", "verify_signup");
    formDatas.append("otp", OTP);
    try {
      const response = await post("/user.php", formDatas);

      const result = response.data;
      console.log(result);

      if (response.status === 200) {
        message.success("Email Verify successfully!");
        // message.success('Email verified successfully!');
        setOtpSent(false);
        setVerifyEmail(true);
      } else {
        message.error(result.message || "Failed to verify email.");
      }
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code that falls out of the range of 2xx
        message.error(error.response.data.message || "Failed to verify email.");
      } else if (error.request) {
        // The request was made but no response was received
        message.error("No response received from the server.");
      } else {
        // Something happened in setting up the request that triggered an Error
        message.error("An error occurred while verifying the email.");
      }
    }
  };
  // console.log(countriess)

  return (
    <>
      <div className="col-md-6 col-sm-12">
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "This field is required." }]}
        >
          <Input
            name="name"
            prefix={<UserOutlined />}
            value={formData.name}
            onChange={handleChange}
            className="registration-antd-input-tag"
          />
        </Form.Item>
      </div>
      <div className="col-md-6 col-sm-12">
        <Form.Item
          label="User Name"
          prefix={<UserOutlined />}
          name="username"
          rules={[{ required: true, message: "This field is required" }]}
        >
          <Input
            name="username"
            value={formData.username}
            prefix={<UserOutlined />}
            onChange={(e) => checkAvailability("user_name", e.target.value)}
            className="registration-antd-input-tag registration-input-tag"
          />
        </Form.Item>
        {verifyEmail && (
          <div>
            <span className="d-flex email-verification-text  align-items-center">
              <label className="">
                {" "}
                <BiSolidCheckboxChecked />
              </label>
              <label className=""> Username is Available</label>
            </span>
          </div>
        )}
      </div>

      <div className="col-md-6 col-sm-12">
        <Form.Item
          label="Password"
          name="password"
          rules={[{ required: true, message: "This field is required." }]}
        >
          <Input.Password
            name="password"
            prefix={<LockOutlined />}
            className="registration-antd-input-tag"
            value={formData.password}
            onChange={handleChange}
          />
        </Form.Item>
      </div>

      <div className="col-md-6 col-sm-12">
        <Form.Item
          label="Confirm Password"
          name="confirmPassword"
          rules={[
            { required: true, message: "This field is required." },
            { validator: validateConfirmPassword }, // Use custom validation function
          ]}
        >
          <Input.Password
            name="confirmPassword"
            prefix={<LockOutlined />}
            value={formData.confirmPassword}
            onChange={handleChange}
            className="registration-antd-input-tag"
          />
        </Form.Item>
      </div>
      <div className="col-md-6 col-sm-12">
        <div className="d-flex justify-content-between align-items-center">
          <Form.Item
            label="Email "
            name="email"
            style={{ width: "90%" }}
            // className='Account-email-input-field'
            rules={[
              {
                required: true,
                type: "email",
                message: "This field is required.",
              },
            ]}
          >
            <Input
              name="email"
              value={formData.email}
              // onChange={handleChange}
              onChange={(e) => checkAvailability("user_email", e.target.value)}
              prefix={<MdEmail />}
              disabled={verifyEmail}
              // style={{width:"90%"}}
              className="registration-antd-input-tag Account-email-input-field"
            />
          </Form.Item>

          {!otpSent ? (
            <Button
              loading={loading}
              disabled={loading}
              type="primary"
              onClick={handleEmailVerification}
            >
              Verify
            </Button>
          ) : (
            <Button
              type="primary"
              disabled={verifyEmail}
              className="sumbit-otp-btn"
              onClick={sumbitOtp}
            >
              Submit OTP
            </Button>
          )}
          {/* <Button type="primary" onClick={handleEmailVerification}>
                        Verify
                    </Button> */}
        </div>
        {verifyEmail && (
          <div>
            <span className="d-flex email-verification-text  align-items-center">
              <label className="">
                <BiSolidCheckboxChecked />
              </label>
              <label className=""> Email verified successfully!</label>
            </span>
          </div>
        )}

        {otpSent && (
          <>
            <OTPInput
              value={OTP}
              onChange={setOTP}
              autoFocus
              OTPLength={6}
              otpType="number"
              disabled={false}
              secure
            />
            <div className="mt-3">
              <ResendOTP
                className="registration-resend-otp"
                onResendClick={handleEmailVerification}
              />
            </div>
          </>
        )}
      </div>

      <div className="col-md-6 col-sm-12">
        <Form.Item
          label="Phone No "
          name="phoneNumber"
          rules={[{ required: true, message: "This field is required." }]}
        >
          <Input
            name="phoneNumber"
            value={formData.phoneNumber}
            prefix={<MdCall />}
            onChange={(e) => checkAvailability("number", e.target.value)}
            // onChange={handleChange}
            className="registration-antd-input-tag"
          />
        </Form.Item>
      </div>
      <div className="col-md-6 col-sm-12">
        <Form.Item
          label="Country "
          name="country"
          rules={[{ required: true, message: "This field is required." }]}
        >
          <Select
            showSearch
            placeholder="Select The Country"
            className="registration-antd-input-tag"
            name="country"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {countries?.map((country, index) => (
              <Option key={index} value={country} prefix={<GiWorld />}>
                {country}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </div>
      <div className="col-md-6 col-sm-12">
        <Form.Item
          label="Referred By "
          name="referedBy"
          rules={[{ required: true, message: "This field is required." }]}
        >
          <Select
            showSearch
            placeholder="Referred By"
            className="registration-antd-input-tag"
            name="referedBy"
            optionFilterProp="children"
            onChange={handleCountryChange}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {referBy?.map((refer, index) => (
              <Option key={index} value={refer.user_id} prefix={<GiWorld />}>
                {refer.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </div>
    </>
  );
};

export default Account;
